export function installationLogo() {
    return {
        restrict: 'E',
        scope: {},
        controller: InstallationLogoController,
        controllerAs: 'vm',
        templateUrl: 'app/components/installation-logo.directive.html'
    };
}

class InstallationLogoController {
    constructor(destinationService) {
        this.destinationService = destinationService;
        this.destinationService.getDestinationInstallation()
            .then(response => {
                this.destinationInstallation  = response;
                this._resolveInstallationLogo();
            });
    }

    _resolveInstallationLogo() {
        if (this.destinationInstallation) {
            var baseUrl = this.destinationInstallation.baseUrl + '/' + this.destinationInstallation.workerName + '/graphic/ws/';
            this.logoUrl = baseUrl + 'systemLogo';
        }
    }
}
InstallationLogoController.$inject = ['destinationService'];